import React from "react";

import { Typography } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import useOperatorCurrency from "globals/hooks/useOperatorCurrency";

type AmountDueColumnProps = {} & GridRenderCellParams<string>

function AmountDueColumn(props: AmountDueColumnProps) {
  const { row } = props;
  const currency = useOperatorCurrency();

  return <Typography variant="subtitle2">{currency(row.amountDue)}</Typography>;
}

export default AmountDueColumn;
